export const MIN = 1
export const MAX = 50

function sanitizeInput (value, resource) {
  const isBlank = value.length === 0
  if (isBlank) {
    return ''
  }
  const isInRange = value >= MIN && value <= MAX
  const valueAsNumber = Number(value)
  const isInteger = Number.isInteger(valueAsNumber)
  if (isInRange && isInteger) {
    return valueAsNumber
  }
  return resource.multiplier
}

function isMultiplierField (field) {
  return field.prop === 'multiplier'
}

export function isNotMultiplierField (field) {
  return !isMultiplierField(field)
}

export const multiplierField = {
  name: 'Multiplier',
  prop: 'multiplier',
  type: 'number',
  min: MIN,
  max: MAX,
  filter: sanitizeInput
}
